<template>
	<div>
		<div style="display: inline-flex; align-items: center">
			<div>
				<h2>Collaborate On This Workflow</h2>
			</div>
		</div>
		<p style="margin-top: 0px">
			Invite coleagues accross your organisation to collaborate on the
			<b>{{ workflowToCollaborateOn.name }}</b> workflow
		</p>
		<el-divider class="compressedDivider"></el-divider>
		<el-autocomplete
			:fetch-suggestions="searchUsers"
			clearable
			placeholder="Search for collaborators by username"
			prefix-icon="el-icon-search"
			v-model="usersSearch"
			style="width: 100%; margin-top: 20px"
		>
			<el-select style="width: 150px" v-model="permissionLevel" slot="prepend" placeholder="Permissions">
				<el-option label="Can view only" value="read"></el-option>
				<el-option label="Can edit" value="read/write"></el-option>
			</el-select>
			<el-button @click="addCollaborator()" v-if="determineIfToShowAdd()" slot="append"
				>Add as collaborator</el-button
			>
		</el-autocomplete>
		<el-divider class="compressedDivider"></el-divider>
		<el-container v-loading="operationInProgress">
			<el-main style="padding: 0px; padding-top: 20px; height: 400px; overflow: scroll">
				<ul v-if="workflowToCollaborateOn.collaborators.length">
					<li :key="user.applicationUserID" v-for="user in workflowToCollaborateOn.collaborators">
						<el-avatar
							:style="{
								backgroundColor: returnColor(user.username),
								fontWeight: 'bold',
								fontSize: '18px',
							}"
						>
							{{ user.username.charAt(0).toUpperCase() }}
						</el-avatar>
						<h4 style="margin-left: 20px">{{ user.username }}</h4>
						<el-tag style="margin-left: auto; margin-right: 20px" type="info"
							>Permissions: <b>{{ user.access === "read" ? "Can view only" : "Can edit" }}</b></el-tag
						>
						<el-button
							:loading="userRemovalInProgress === user.applicationUserID"
							@click="removeCollaborator(user)"
							type="danger"
							icon="el-icon-delete"
							circle
						></el-button>
					</li>
				</ul>
				<el-empty
					style="padding: 0px"
					:image="require('../assets/empty.svg')"
					v-if="!workflowToCollaborateOn.collaborators.length"
					description="No Collaborators"
				></el-empty>
			</el-main>
		</el-container>
	</div>
</template>

<script>
import Vue from "vue";
import { returnColor } from "../utils/general.js";
export default {
	props: {
		workflowToCollaborateOn: Object,
	},
	watch: {
		workflowToCollaborateOn: function () {
			this.usersSearch = "";
			this.operationInProgress = true;
			setTimeout(() => {
				this.operationInProgress = false;
			}, 500);
		},
	},
	data() {
		return {
			permissionLevel: "read",
			usersSearch: "",
			operationInProgress: false,
			timeout: null,
			users: [],
			userRemovalInProgress: null,
		};
	},
	async mounted() {
		await this.fetchUsers();
	},
	methods: {
		async addCollaborator() {
			if (!this.determineIfToShowAdd()) {
				return;
			}
			const relevantUser = this.users.find((each) => {
				return each.username === this.usersSearch;
			});
			const userIsAlreadyCollaborator = this.workflowToCollaborateOn.collaborators.find((each) => {
				return each.applicationUserID === relevantUser.userID;
			});
			if (userIsAlreadyCollaborator) {
				this.$notify({
					title: "Warning",
					message: relevantUser.username + " is already a collaborator on this workflow",
					type: "warning",
					position: "bottom-left",
				});
				return;
			}
			this.operationInProgress = true;
			const result = await this.httpHelper("RUNTIME", "POST", "workflow/addCollaborativeUserToWorkflow", {
				userID: relevantUser.userID,
				access: this.permissionLevel,
				workflowId: this.workflowToCollaborateOn.workflowId,
			});
			setTimeout(() => {
				this.operationInProgress = false;
				if (!result?.error) {
					this.workflowToCollaborateOn.collaborators.push(result.response);
					this.$notify({
						title: "Success",
						message: relevantUser.username + " added as collaborator",
						type: "success",
						position: "bottom-left",
					});
				} else {
					this.$notifyError(this, result.error);
				}
			}, 500);
		},
		async removeCollaborator(user) {
			this.userRemovalInProgress = user.applicationUserID;
			this.operationInProgress = true;
			const result = await this.httpHelper("RUNTIME", "DELETE", "workflow/removeCollaborativeUserFromWorkflow", {
				userID: user.applicationUserID,
				workflowId: this.workflowToCollaborateOn.workflowId,
			});
			setTimeout(() => {
				this.operationInProgress = false;
				this.userRemovalInProgress = null;
				if (!result?.error) {
					this.workflowToCollaborateOn.collaborators = this.workflowToCollaborateOn.collaborators.filter(
						(each) => {
							return each.applicationUserID !== user.applicationUserID;
						}
					);
					this.$notify({
						title: "Success",
						message: user.username + " removed as collaborator",
						type: "success",
						position: "bottom-left",
					});
				} else {
					this.$notifyError(this, result.error);
				}
			}, 500);
		},
		returnColor(string) {
			return returnColor(string);
		},
		determineIfToShowAdd() {
			const searchStringIsValidUser = this.users.find((each) => {
				return each.username === this.usersSearch;
			});
			if (this.usersSearch && this.permissionLevel && searchStringIsValidUser) {
				return true;
			}
			return false;
		},
		searchUsers(queryString, cb) {
			if (!queryString) {
				cb([]);
				return;
			}
			const results = this.users.filter((each) => {
				return each.username.toLowerCase().includes(queryString.toLowerCase());
			});
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(
					results.map((each) => {
						return { value: each.username };
					})
				);
			}, 500);
		},
		async fetchUsers() {
			this.operationInProgress = true;
			const result = await this.httpHelper("RUNTIME", "GET", "security/fetchActiveUsers", {
				organisationName: Vue.$cookies.get("orgName"),
			});
			setTimeout(() => {
				this.operationInProgress = false;
				if (!result?.error) {
					this.users = result.response;
				} else {
					this.$notifyError(this, "unable to retrieve users");
				}
			}, 500);
		},
	},
};
</script>

<style scoped>
.compressedDivider {
	margin-bottom: 0px;
}

li {
	list-style: none;
	display: flex;
	flex-direction: row;
	align-items: center;
}

ul {
	margin-top: 0px;
	padding-left: 0;
}
</style>
